import { useEffect } from 'react'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { useUiStore } from '@/stores/uiStore'
import { LEGAL_ACCEPTANCE_PATH, needsLegalAcceptance } from './onboardingAccess'
import InstructorSidebar from './InstructorSidebar'
import { InstructorLiveNowNotice } from '@/features/liveNow/LiveNowNotices'
import { Spinner } from '@/components/ui'
import { cn } from '@/lib/utils'
import { hasInstructorFeature, missingInstructorRouteFeature, ZOOM_FEATURE } from '@/lib/instructorFeatures'
import InstructorFeatureBlocked from '@/features/instructorPackages/InstructorFeatureBlocked'

export default function InstructorLayout() {
  const { user, isLoading, checkAuth } = useAuthStore()
  const { sidebarCollapsed } = useUiStore()
  const { pathname } = useLocation()

  // `isLoading` do authStore comeca em `true` e so e resolvido pelo checkAuth().
  // Mesmo buraco que o AdminLayout ja tinha corrigido, e que sobrou aqui: abrir
  // /instructor direto na URL (ou dar F5 dentro da area do padrinho) ficava preso no
  // spinner para sempre. So funcionava chegando por navegacao interna, vindo de uma
  // tela sob o DashboardLayout, que resolve o `isLoading` antes. Com a aba do guia
  // (r03-09) a URL /instructor/students/:id passa a ser compartilhavel, entao o
  // caminho de carga direta deixou de ser hipotetico.
  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-900">
        <Spinner size="lg" />
      </div>
    )
  }

  // Check if user is instructor or admin
  if (!user || (user.role !== 'instructor' && user.role !== 'admin')) {
    return <Navigate to="/app/dashboard" replace />
  }

  // LGPD-05: instrutor tambem aceita os documentos legais.
  if (needsLegalAcceptance(user)) {
    return <Navigate to={LEGAL_ACCEPTANCE_PATH} replace />
  }

  return (
    <div className="min-h-screen bg-neutral-900">
      <InstructorSidebar />
      <main className={cn(
        'transition-all duration-300',
        sidebarCollapsed ? 'lg:pl-16' : 'lg:pl-64'
      )}>
        <div className="p-6 lg:p-8">
          {/* R10-12: aula que o instrutor conduz agora. */}
          {/* Revisao R10-14: o aviso leva a /instructor/aulas-ao-vivo, que exige o pacote Zoom. */}
          {hasInstructorFeature(user, ZOOM_FEATURE) && <InstructorLiveNowNotice />}
          {/* R10-14: rota fora dos pacotes do padrinho vira aviso. */}
          {missingInstructorRouteFeature(user, pathname) ? <InstructorFeatureBlocked /> : <Outlet />}
        </div>
      </main>
    </div>
  )
}
